import { FunctionComponent as F } from 'react';
import { Route, Routes } from 'react-router-dom';
import Account from '../../pages/Account/Account';
import ChangePassword from '../../pages/Account/ChangePassword';
import Login from '../../pages/Account/Login';
import CreateAccount from '../../pages/Account/CreateAccount';
import Protocol from '../../pages/Protocol';
import SplashScreen from '../../pages/SplashScreen';
import About from '../../pages/About/About';
import {
  ACCOUNT,
  CHANGE_PASSWORD,
  HOME,
  LOGIN,
  PROTOCOL,
  ABOUT,
  CONTACT,
  BLOG,
  MM_INDEX,
  TOPIC,
  FUNDRAISERS,
  PRODUCTS,
  LISTINGS,
  NEW,
  CHANGE_USERNAME,
  SIMILAR,
  SAVINGS,
  VENDORS,
  SUBMIT_TAX,
  NEW_PRICE,
  LICENSES,
  PRICE_UPDATE_STATUS,
  UNSUBSCRIBE,
  SAVE_PUBLIC_PROTOCOL,
  MM_PROTOCOL as MM_PROTOCOL,
  SAVE_MM_PROTOCOL,
  ADD_REF,
  PROTOCOL_BUILDER,
  COMBINE_PROTOCOLS,
  DELETE_ACCOUNT} from './paths';
import Contact from '../../pages/Contact';
import Blog from '../../pages/Blog/Blog';
import Topic from '../../pages/MmIndex/Topic';
import Fundraisers from '../../pages/Fundraisers';
import ProductSearch from '../../components/Products/ProductSearch';
import ChooseListing from '../../components/Listings/ChooseListing';
import NewListing from '../../components/Listings/NewListing';
import NewProduct from '../../components/Products/NewProduct';
import ChangeUsername from '../../pages/Account/ChangeUsername';
import SimilarProducts from '../../components/Products/SimilarProducts';
import Savings from '../../components/Savings/Savings';
import SubmitTax from '../../components/Vendor/SubmitTax';
import NewPrice from '../../components/Listings/NewPrice';
import Licenses from '../../pages/Licenses/Licenses';
import PriceUpdateStatus from '../../pages/PriceUpdateStatus';
import Unsubscribe from '../../pages/Unsubscribe';
import MmIndex from '../../pages/MmIndex/MmIndex';
import MmProtocols from '../../pages/MmProtocols/MmProtocols';
import MmProtocol from '../../pages/MmProtocols/MmProtocol';
import AddRef from '../../components/Topic/AddRef';
import ProtocolBuilder from '../../pages/ProtocolBuilder/ProtocolBuidler';
import CombineProtocols from '../../pages/CombineProtocols';
import DeleteAccount from '../../pages/Account/DeleteAccount';



export const AppRouter: F = () =>
{
  return (
    <Routes>
      <Route path={HOME + "/*"} element={<SplashScreen/>} />

      <Route path={PROTOCOL} element={<Protocol/>}/>
      <Route path={PROTOCOL + "/:protocolId/*"} element={<Protocol/>}/>

      <Route path={PROTOCOL + "/:protocolId/" + PRODUCTS} element={<><Protocol/><ProductSearch/></>}/>
      <Route path={PROTOCOL + "/:protocolId/" + PRODUCTS + "/" + NEW} element={<><Protocol/><NewProduct/></>}/>
      <Route
        path={PROTOCOL + "/:protocolId/" + PRODUCTS + "/:productId/" + LISTINGS }
        element={<><Protocol/><ChooseListing/></>}/>

      <Route
        path={PROTOCOL + "/:protocolId/" + PRODUCTS + "/:productId/" + LISTINGS + "/" + NEW}
        element={<><Protocol/><NewListing/></>}/>
      <Route
        path={PROTOCOL + "/:protocolId/" + PRODUCTS + "/:productId/" + LISTINGS + "/" + NEW + "/" + PRODUCTS}
        element={<><Protocol/><NewListing/><ProductSearch/></>}/>

      <Route
        path={PROTOCOL + "/:protocolId/" + PRODUCTS + "/:productId/" + LISTINGS +"/:listingId/" + NEW_PRICE}
        element={<><Protocol/><NewPrice/></>}/>

      <Route path={PROTOCOL + "/:protocolId/" + PRODUCTS + "/:productId/" + SIMILAR}
        element={<><Protocol/><SimilarProducts/></>}/>

      <Route path={PROTOCOL + "/:protocolId/" + VENDORS + "/:vendorId/" + SUBMIT_TAX}
        element={<><Protocol/><SubmitTax/></>}/>

      {/*TODO: Include productId in route params later so location sharable - must check if productId is in protocol
       on loading the Savings cpt*/}
      <Route path={PROTOCOL + "/:protocolId/" + SAVINGS} element={<><Protocol/><Savings/></>}/>

      <Route path={MM_PROTOCOL} element={<MmProtocols/>}/>
      <Route path={MM_PROTOCOL + "/:mmProtocolId"} element={<MmProtocol/>}/>

      <Route path={PROTOCOL_BUILDER} element={<ProtocolBuilder/>}/>

      <Route path={PRICE_UPDATE_STATUS} element={<PriceUpdateStatus/>}/>

      <Route path={LOGIN} element={<Login/>} />
      <Route path={LOGIN + "/" + NEW} element={<CreateAccount/>} />
      <Route path={LOGIN + "/" + SAVE_PUBLIC_PROTOCOL} element={<Login/>} />
      <Route path={LOGIN + "/" + SAVE_MM_PROTOCOL} element={<Login/>} />

      <Route path={ACCOUNT + "/*"} element={<Account/>}>
        <Route path={CHANGE_PASSWORD} element={<><Account/><ChangePassword/></>}/>
        <Route path={CHANGE_USERNAME + "/:key"} element={<><Account/><ChangeUsername/></>}/>
      </Route>

      <Route path={COMBINE_PROTOCOLS} element={<CombineProtocols/>} />

      <Route path={CHANGE_PASSWORD + "/:key"} element={<ChangePassword/>}/>
      <Route path={UNSUBSCRIBE + "/:userId" + "/:userIdHash"} element={<Unsubscribe/>}/>
      <Route path={DELETE_ACCOUNT} element={<DeleteAccount/>}/>

      <Route path={FUNDRAISERS} element={<Fundraisers/>} />
      <Route path={BLOG + "/*"} element={<Blog/>} />
      <Route path={ABOUT + "/*"} element={<About/>} />
      <Route path={CONTACT} element={<Contact/>} />

      <Route path={LICENSES + "/*"} element={<Licenses/>} />

      <Route path={MM_INDEX} element={<MmIndex/>}/>
      <Route path={MM_INDEX + "/" + TOPIC + "/:topicId"} element={<Topic/>}/>
      <Route path={MM_INDEX + "/" + TOPIC + "/:topicId/" + ADD_REF} element={<><Topic/><AddRef/></>}/>

    </Routes>);
};
